// extracted by mini-css-extract-plugin
export var externalLink = "_az-0";
export var internalLinkLabel = "_az-1";